import { Modal, Select } from "antd";
import React, { useEffect, useState } from "react";
import { href } from "react-router";
import { convertIdToSuperscript } from "./Leftpanel";

const AddCitation = ({ editor, handleCancel, setShow }) => {
  const [modifiedhref, setModifiedhref] = useState({
    href: "",
    "ref-type": "",
    rid: "",
    "data-mce-href": "",
    text: "",
  });
  const [currentCitation, setCurrentCitation] = useState("ref");
  const [selectData, setSelectData] = useState([]);
  const [selectedNode, setSelectedNode] = useState(null);

  let refEles = editor?.dom.select("ref");
  let figEles = editor?.dom.select("fig");
  let tableEles = editor?.dom.select("table-wrap");
  let affEles = editor?.dom.select("aff");
  let secEles = editor?.dom.select("sec");
  let EquationEles = editor?.dom.select("disp-formula") || [];

EquationEles = EquationEles.filter((el) => {
  const id = el.getAttribute("id");
  return /^disp\d+$/.test(id); 
});
console.log(EquationEles,"Equation");

  let fNote = editor?.dom.select("fn").filter((fn) => {
    const id = fn.getAttribute("id");
    return /^fn-\d+$/.test(id);
  });

  const handleChange = (e, type) => {
    if (type === "href") {
      setModifiedhref((prev) => ({ ...prev, href: e.target.value }));
    } else if (type === "ref-type") {
      setModifiedhref((prev) => ({ ...prev, "ref-type": e.target.value }));
    } else if (type === "rid") {
      setModifiedhref((prev) => ({ ...prev, rid: e.target.value }));
    } else if (type === "data-mce-href") {
      setModifiedhref((prev) => ({ ...prev, "data-mce-href": e.target.value }));
    } else {
      setModifiedhref((prev) => ({ ...prev, text: e.target.value }));
    }
  };

  function generateRandomId(prefix = "") {
    return prefix + Math.random().toString(36).substr(2, 5); // Generate a random alphanumeric ID
  }

  useEffect(() => {
    if (currentCitation === "ref") {
      setSelectData(refEles);
    } else if (currentCitation === "fig") {
      setSelectData(figEles);
    } else if (currentCitation === "table") {
      setSelectData(tableEles);
    } else if (currentCitation === "sec") {
      setSelectData(secEles);
    } else if (currentCitation === "fn") {
      setSelectData(fNote);
    }else if (currentCitation === "eqn") {
      setSelectData(EquationEles);
    } else {
      setSelectData(affEles);
    }
  }, [currentCitation]);


  const handleSelect = (node) => {
    setSelectedNode(selectData[node]);
  };

  

  useEffect(() => {
    let id = selectedNode?.getAttribute("id");
    const ref_type = currentCitation === "ref" ? "bibr" : currentCitation;
    let num =
      currentCitation === "sec"
        ? convertIdToSuperscript(id)
        : id?.replace(/\D/g, "");
    // const modid =
    //   currentCitation === "ref"
    //     ? `ref-${num}`
    //     : currentCitation === "fig"
    //     ? `fig-${num}`
    //     : `table-${num}`;

    const text =
      currentCitation === "ref" || currentCitation === "aff"
        ? num
        : currentCitation === "fig"
        ? `Fig.${num}`
        : currentCitation === "sec"
        ? ` S${num} `
        : currentCitation === "fn"
        ? ` fn-${num} ` : currentCitation === "eqn"
        ? ` Eqs. ${num} `
        : `Table ${num}`;

    if (id) {
      setModifiedhref({
        href: `#${id}`,
        "ref-type": ref_type,
        rid: id,
        "data-mce-href": `#${id}`,
        text: text,
      });
    }
  }, [selectedNode]);

  const insertCitation = () => {
    if (
      !modifiedhref ||
      Object.keys(modifiedhref).length === 0 ||
      Object.values(modifiedhref).some((val) => !val || !val.toString().trim())
    ) {

      return ;
    }
    const attributes = {
      href: modifiedhref.href,
      "ref-type": modifiedhref["ref-type"],
      rid: modifiedhref.rid,
      "data-mce-href": modifiedhref["data-mce-href"],
      key: generateRandomId(),
    };

    const attrString = Object.entries(attributes)
      .map(([key, value]) => `${key}="${value}"`)
      .join(" ");

    const xrefHTML =
      modifiedhref["ref-type"] === "bibr"
        ? `[ <xref ${attrString}>${modifiedhref.text}</xref> ]`
        : `<xref ${attrString}>${modifiedhref.text}</xref>`;
   editor.undoManager.transact(() => {
    editor?.selection.setContent(xrefHTML);
   })
    handleCancel();
  };

  return (
    <Modal
      title="Add Citation"
      open={setShow}
      onOk={insertCitation}
      maskClosable={false}
      onCancel={handleCancel}
      zIndex={10}
    >
      <div className="flex gap-x-5 gap-y-3 items-center flex-wrap mb-5 ">
        <div className="flex gap-2 items-center">
          <label className="w-full">Reference</label>
          <input
            type="radio"
            name="citations"
            value={"ref"}
            defaultChecked
            onChange={(e) => {
              setCurrentCitation(e.target.value);
              setModifiedhref("");
            }}
          />
        </div>
        <div className="flex gap-2 items-center">
          <label className="w-full">Figure</label>
          <input
            type="radio"
            name="citations"
            value={"fig"}
            onChange={(e) => {
              setCurrentCitation(e.target.value);
              setModifiedhref("");
            }}
          />
        </div>
        <div className="flex gap-2 items-center">
          <label className="w-full">Table</label>
          <input
            type="radio"
            name="citations"
            value={"table"}
            onChange={(e) => {
              setCurrentCitation(e.target.value);
              setModifiedhref("");
            }}
          />
        </div>
        <div className="flex gap-2 items-center">
          <label className="w-full">Affiliation</label>
          <input
            type="radio"
            name="citations"
            value={"aff"}
            onChange={(e) => {
              setCurrentCitation(e.target.value);
              setModifiedhref("");
            }}
          />
        </div>
        <div className="flex gap-2 items-center">
          <label className="w-full">Section</label>
          <input
            type="radio"
            name="citations"
            value={"sec"}
            onChange={(e) => {
              setCurrentCitation(e.target.value);
              setModifiedhref("");
            }}
          />
        </div>
        <div className="flex gap-2 items-center">
          <label className="w-full">Text FootNote</label>
          <input
            type="radio"
            name="citations"
            value={"fn"}
            onChange={(e) => {
              setCurrentCitation(e.target.value);
              setModifiedhref("");
            }}
          />
        </div>
          <div className="flex gap-2 items-center">
          <label className="w-full">Equations</label>
          <input
            type="radio"
            name="citations"
            value={"eqn"}
            onChange={(e) => {
              setCurrentCitation(e.target.value);
              setModifiedhref("");
            }}
          />
        </div>
      </div>
      <div className="flex w-full flex-col gap-4 mt-2">
        <div className="flex flex-col gap-1 w-full">
          <label className="w-full">
            {`Select 
            ${
              currentCitation === "ref"
                ? "Reference"
                : currentCitation === "fig"
                ? "Figure"
                : currentCitation === "table"
                ? "Table"
                : currentCitation === "sec"
                ? "Section"
                : currentCitation === "fn"
                ? "Text FootNote" 
                : currentCitation === "eqn"
                ? "Equations"
                : "Affiliation"
            }
            to Link:`}
          </label>
          <select
            className="px-2 border-[1px] outline-[#006CE7] border-[#eeeeee] w-full rounded-[6px] py-3"
            type="text"
            onChange={(e) => handleSelect(e.target.value)}
          >
            <option defaultValue>Choose an option</option>
            {selectData.map((item, i) => (
              <option key={i} value={i}>
                {item.getAttribute("id")}
              </option>
            ))}
          </select>
        </div>
        <div className="flex flex-col gap-1 w-full">
          <label className="w-full">Link :</label>
          <input
            className="px-2 border-[1px] outline-[#006CE7] border-[#eeeeee] w-full rounded-[6px] py-3"
            type="text"
            value={modifiedhref.href || ""}
            onChange={(e) => handleChange(e, "href")}
          />
        </div>
        <div className="flex flex-col gap-1 w-full">
          <label className="w-full">Ref-Type :</label>
          <input
            className="px-2 border-[1px] outline-[#006CE7] border-[#eeeeee] w-full rounded-[6px] py-3"
            type="text"
            value={modifiedhref["ref-type"] || ""}
            onChange={(e) => handleChange(e, "ref-type")}
          />
        </div>
        <div className="flex flex-col gap-1 w-full">
          <label className="w-full">rid :</label>
          <input
            className="px-2 border-[1px] outline-[#006CE7] border-[#eeeeee] w-full rounded-[6px] py-3"
            type="text"
            value={modifiedhref["rid"] || ""}
            onChange={(e) => handleChange(e, "rid")}
          />
        </div>
        <div className="flex flex-col gap-1 w-full">
          <label className="w-full">data-mce-href :</label>
          <input
            className="px-2 border-[1px] outline-[#006CE7] border-[#eeeeee] w-full rounded-[6px] py-3"
            type="text"
            value={modifiedhref["data-mce-href"] || ""}
            onChange={(e) => handleChange(e, "data-mce-href")}
          />
        </div>
        <div className="flex flex-col gap-1 w-full">
          <label className="w-full">Text :</label>
          <input
            className="px-2 border-[1px] outline-[#006CE7] border-[#eeeeee] w-full rounded-[6px] py-3"
            type="text"
            value={modifiedhref["text"] || ""}
            onChange={(e) => handleChange(e, "text")}
          />
        </div>
      </div>
    </Modal>
  );
};

export default AddCitation;
